import { render, staticRenderFns } from "./control-switch-btn.vue?vue&type=template&id=09f21a34&"
import script from "./control-switch-btn.vue?vue&type=script&lang=js&"
export * from "./control-switch-btn.vue?vue&type=script&lang=js&"
import style0 from "./control-switch-btn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports